/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_viewer = {
    readonly isSbMobileGridToggleDisabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_viewer">;
    readonly " $refType": "SharedItemTile_viewer";
};
export type SharedItemTile_viewer$data = SharedItemTile_viewer;
export type SharedItemTile_viewer$key = {
    readonly " $data"?: SharedItemTile_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedItemTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSbMobileGridToggleDisabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "isSbMobileGridToggleDisabled"
        }
      ],
      "storageKey": "isEnabled(key:\"isSbMobileGridToggleDisabled\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTile_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '3fe2193f601a7d2f149b7f931329ab5b';
export default node;
